import React from "react";
import { Stamp } from "lucide-react";

export default function StampBadge({ amount }) {
  return (
    <div className="flex flex-col items-center justify-center rounded-full shrink-0 text-primary border-[3px] border-double border-primary rotate-[-8deg] w-[108px] h-[108px]">
      <Stamp size={16} className="mb-1" />
      <div className="text-[9px] leading-3 text-center px-1 text-neutral-200">تمبر مالیاتی</div>
      <div className="text-[11px] font-bold text-center px-1 leading-tight text-neutral-200">
        {amount}
      </div>
    </div>
  );
}
